
export const getPartnerReportURL = (state, type, slug) => getBase(state, type, slug).data
export const isRequestingPartnerReportURL = (state, type, slug) => getBase(state, type, slug).isRequesting
export const didFailToRequestPartnerReportURL = (state, type, slug) => getBase(state, type, slug).didRequestFail

function getBase (state, type, slug) {
  const o = state.metadataMetrics[type] || {}
  return o[slug] || {}
}



// WEBPACK FOOTER //
// ./selectors/metadata-reports.js